import React, { useState, useEffect } from "react";
import i18n from "../../i18n/config";
import { useDispatch, useSelector } from "react-redux";
import { SetShowCancelModal, UpdateBankAcccountParams, UpdateBankAccountFormFields } from "../../actions/bankAccounts";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import { RootState } from "../../types/redux";

import Modal from "../Common/Modal";
import { ACTION_DISPLAY_TYPES, BANK_ACCOUNT_FLOW_TYPES } from "../../constants/enums";
import { setIsInert } from "../../actions/global";

const CancelModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { type, showCancelModal } = useSelector((state: RootState) => state.bankAccounts);
  const [content, setContent] = useState(i18n.t("PAGES.BANK_ACCOUNTS.BENEFICIARY_BANK_DETAILS.CANCEL_MODAL_TEXT"));
  const [actions, setActions] = useState<Array<{
    title: string;
    onClick: () => void;
    displayType: number;
    className?: string;
  }>>([]);

  /**
   * Set the content of the cancel modal based on the flow type
   */
  useEffect(() => {
    if (type === BANK_ACCOUNT_FLOW_TYPES.EDIT) {
      setContent(i18n.t("PAGES.BANK_ACCOUNTS.BENEFICIARY_BANK_DETAILS.EDIT_FLOW_CANCEL_MODAL_TEXT"));
      setActions([
        {
          title: i18n.t("COMMON.NO"),
          onClick: () => dispatch(SetShowCancelModal(false)),
          displayType: ACTION_DISPLAY_TYPES.SECONDARY,
        },
        {
          title: i18n.t("COMMON.YES"),
          onClick: () => handleReturnToBankAccounts(),
          displayType: ACTION_DISPLAY_TYPES.PRIMARY,
          className: "btn btn-primary",
        },
      ]);
    } else {
      setActions([
        {
          title: i18n.t("COMMON.NO"),
          onClick: () => {
            dispatch(SetShowCancelModal(false));
            dispatch(setIsInert(false));
          },
          displayType: ACTION_DISPLAY_TYPES.SECONDARY,
        },
        {
          title: i18n.t("COMMON.YES"),
          onClick: () => handleCancelModal(),
          displayType: ACTION_DISPLAY_TYPES.PRIMARY,
          className: "btn btn-primary",
        },
      ])
    }
  }, []);

  /**
   * Handle user clicking on "Yes" in the cancel modal
   **/
  const handleCancelModal = async () => {
    dispatch(SetShowCancelModal(false));
    dispatch(setIsInert(false));
    history.push(ROUTES.BANKS_ACCOUNTS.COUNTRY);
  }

  const handleReturnToBankAccounts = () => {
    dispatch(SetShowCancelModal(false));
    dispatch(setIsInert(false));
    dispatch(UpdateBankAccountFormFields(null));
    dispatch(UpdateBankAcccountParams(null, null));
    history.push(ROUTES.BANKS_ACCOUNTS.INDEX);
  }

  // Wrapping in order to ensure react-modal styles are cleaned up and not causing issues on unmount and page navigation
  return (
    <>
      {showCancelModal &&
        <Modal
          open={showCancelModal}
          onClose={() => {
            dispatch(SetShowCancelModal(false));
            dispatch(setIsInert(false));
          }}
          title={i18n.t("COMMON.CANCEL")}
          content={content}
          actions={actions}
          className="text-center"
        />
      }
    </>

  );
}

export default CancelModal;